import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    text: 'Lo mejor fue dejar de sentirme culpable por descansar. Ahora el descanso me recarga de verdad.',
    author: 'Sofía, 31, Rosario'
  }, {
    text: 'Es como si me hubieran quitado un peso invisible. En solo 5 días noté la diferencia.',
    author: 'Valentina, 29, Mendoza'
  }, {
    text: 'Recuperé energía sin agregar nada a mi vida. Solo solté lo que no servía.',
    author: 'Camila, 36, La Plata'
  }];
  return <Section background="white" data-id="element-319">
      <div className="text-center mb-16" data-id="element-320">
        <h2 className="text-4xl md:text-5xl font-serif italic text-navy mb-6" data-id="element-321">
          Lo que dicen otras mujeres
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-322">
        {testimonials.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.1,
        duration: 0.8,
        ease: 'easeOut'
      }} viewport={{
        once: true
      }} className="bg-cream/50 p-8 rounded-[2rem] border border-dusty-rose/20 relative" data-id="element-323">
            <Quote className="w-8 h-8 text-mauve/20 absolute top-8 right-8" data-id="element-324" />

            <div className="flex items-center gap-3 mb-6" data-id="element-325">
              <div className="w-10 h-10 rounded-full bg-dusty-rose/10 flex items-center justify-center text-lg" data-id="element-326">
                👩
              </div>
              <p className="text-xs text-dusty-rose font-bold uppercase tracking-widest" data-id="element-327">
                {item.author}
              </p>
            </div>

            <p className="text-base text-navy font-light leading-relaxed italic" data-id="element-328">
              "{item.text}"
            </p>
          </motion.div>)}
      </div>
    </Section>;
}